// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-authority .data-scope {\n  display: inline-block;\n  margin-left: 15px;\n  color: #1890ff;\n  cursor: pointer;\n}\n.no-data-show {\n  display: flex;\n  justify-content: center;\n  height: 20px;\n  line-height: 20px;\n  font-size: 18px;\n  margin-top: 10%;\n}\n.no-data-show img {\n  width: 20px;\n}", ""]);
// Exports
module.exports = exports;
